import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { JoveAutocomplete } from '@jove-frontend/mui';
import { Box } from '@mui/material';
import { debounce } from 'lodash';
import { apiQueryCompanyList } from '../../../api/quoteApi';
import { jsx as _jsx } from "react/jsx-runtime";
export var JoveSearchCompanyView = function JoveSearchCompanyView(props) {
  var selectCompany = props.selectCompany,
      label = props.label,
      hideDisplayMoreAddressLabelInfo = props.hideDisplayMoreAddressLabelInfo;

  var _useState = useState([]),
      companyList = _useState[0],
      setCompanyList = _useState[1];

  var _useState2 = useState(false),
      searchCompanyLoading = _useState2[0],
      setSearchCompanyLoading = _useState2[1];

  var _useState3 = useState(null),
      selectedCompany = _useState3[0],
      setSelectedCompany = _useState3[1];
  /**
   * requests
   */


  var requestSearchAddressList = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var _e$target, _e$target2, _results;

      var _yield$apiQueryCompan, _yield$apiQueryCompan2, res, list;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (e !== null && e !== void 0 && (_e$target = e.target) !== null && _e$target !== void 0 && _e$target.value) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setCompanyList([]);
              setSearchCompanyLoading(true);
              _context.next = 6;
              return apiQueryCompanyList({
                query: e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value,
                hideDisplayMoreAddressLabelInfo: hideDisplayMoreAddressLabelInfo
              });

            case 6:
              _yield$apiQueryCompan = _context.sent;
              _yield$apiQueryCompan2 = _slicedToArray(_yield$apiQueryCompan, 1);
              res = _yield$apiQueryCompan2[0];
              list = (res === null || res === void 0 ? void 0 : (_results = res.results) === null || _results === void 0 ? void 0 : _results.items) || [];
              setSearchCompanyLoading(false);
              setCompanyList(list);
              return _context.abrupt("return", list);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestSearchAddressList(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * methods
   */


  var requestSearchAddressListDebounce = debounce(requestSearchAddressList, 300);

  var openSelectOptionAction = function openSelectOptionAction() {
    requestSearchAddressList({
      target: {
        value: (selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.name) || ''
      }
    });
  };

  var selectCompanyAction = function selectCompanyAction(item) {
    setSelectedCompany(item);
    selectCompany === null || selectCompany === void 0 ? void 0 : selectCompany(item);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: "flex flex-col",
    children: /*#__PURE__*/_jsx(JoveAutocomplete, {
      id: "search-company-and-address",
      label: label || 'Search for UK companies',
      getOptionLabel: function getOptionLabel(option) {
        return (option === null || option === void 0 ? void 0 : option.label) || '';
      },
      options: companyList,
      loading: searchCompanyLoading,
      onInputChange: requestSearchAddressListDebounce,
      valueChange: selectCompanyAction,
      onOpen: openSelectOptionAction
    })
  });
};